import React from 'react';
import { Link } from '@klarna/bubble-ui';
import { ContainerTemplate } from '@/components';
import { StakeholderSubGroupComponent } from './StakeholderSubGroupComponent';
export class StakeholderGroupComponent extends React.Component {
    constructor(props) {
        super(props);
        const missingRoles = this.determineMissingSubgroups();
        const currentCollectedRoles = this.getCurrentCollectedRoles();
        const currentRole = currentCollectedRoles.length ? currentCollectedRoles[0] : missingRoles[0];
        this.state = {
            amountOfDeletedItems: 0,
            currentRole,
        };
        this.onPreviousRole = this.onPreviousRole.bind(this);
        this.hasMissingRoles = this.hasMissingRoles.bind(this);
        this.hasNextRole = this.hasNextRole.bind(this);
        this.hasPreviousRole = this.hasPreviousRole.bind(this);
        this.getCurrentRoleFields = this.getCurrentRoleFields.bind(this);
        this.getPreviousRole = this.getPreviousRole.bind(this);
        this.getNextRole = this.getNextRole.bind(this);
        this.determineMissingSubgroups = this.determineMissingSubgroups.bind(this);
        this.getCurrentCollectedRoles = this.getCurrentCollectedRoles.bind(this);
        this.onNext = this.onNext.bind(this);
    }
    determineMissingSubgroups() {
        var _a;
        const { group } = this.props;
        return ((_a = group.determineMissingSubgroups) === null || _a === void 0 ? void 0 : _a.call(group)) || [];
    }
    getCurrentCollectedRoles() {
        var _a, _b;
        const { group } = this.props;
        const collectedRoles = ((_b = (_a = group.payload.business_information) === null || _a === void 0 ? void 0 : _a.persons) === null || _b === void 0 ? void 0 : _b.map(p => p.person_role).flat().filter((role, index, array) => array.indexOf(role) === index)) || [];
        return collectedRoles;
    }
    getMissingRoles() {
        return this.determineMissingSubgroups();
    }
    getPreviousRole() {
        const { currentRole } = this.state;
        const currentCollectedRoles = this.getCurrentCollectedRoles();
        const missingRoles = this.getMissingRoles();
        const currentRoleIndex = currentCollectedRoles.indexOf(currentRole);
        const missingRoleIndex = missingRoles.indexOf(currentRole);
        if (missingRoleIndex > 0) {
            return missingRoles[missingRoleIndex - 1];
        }
        else if (currentRoleIndex > 0) {
            return currentCollectedRoles[currentRoleIndex - 1];
        }
        else {
            return currentCollectedRoles[currentCollectedRoles.length - 1];
        }
    }
    onPreviousRole(e) {
        e.preventDefault();
        const previousRole = this.getPreviousRole();
        this.setState({
            currentRole: previousRole,
        });
    }
    getNextRole() {
        const { currentRole } = this.state;
        const currentCollectedRoles = this.getCurrentCollectedRoles();
        const currentRoleIndex = currentCollectedRoles.indexOf(currentRole) || 0;
        const missingRoles = this.getMissingRoles();
        if (currentRoleIndex !== -1 && currentRoleIndex < currentCollectedRoles.length - 1) {
            return currentCollectedRoles[currentRoleIndex + 1];
        }
        else if (missingRoles.indexOf(currentRole) !== -1) {
            return missingRoles[missingRoles.indexOf(currentRole) + 1];
        }
        else {
            return missingRoles[0];
        }
    }
    onNextRole(e) {
        e.preventDefault();
        const { onNextSubgroup } = this.props;
        const nextRole = this.getNextRole();
        this.setState({
            currentRole: nextRole,
        });
        return onNextSubgroup();
    }
    hasMissingRoles() {
        const missingRoles = this.getMissingRoles();
        return missingRoles.length && missingRoles[missingRoles.length - 1] !== this.state.currentRole;
    }
    hasNextRole() {
        const { currentRole } = this.state;
        const currentRoles = this.getCurrentCollectedRoles();
        return (this.hasMissingRoles() ||
            (currentRoles.indexOf(currentRole) < currentRoles.length - 1 &&
                currentRoles.indexOf(currentRole) !== -1));
    }
    hasPreviousRole() {
        const { currentRole } = this.state;
        const currentRoles = this.getCurrentCollectedRoles();
        const missingRoles = this.getMissingRoles();
        return ((currentRoles.length > 0 && currentRoles.indexOf(currentRole) > 0) ||
            (missingRoles.length > 0 && missingRoles.indexOf(currentRole) > 0) ||
            (missingRoles.indexOf(currentRole) === 0 && currentRoles.length > 0));
    }
    getCurrentRoleFields(currentRole) {
        const { group } = this.props;
        return group.fields.filter(fg => fg.some(f => f.absolutePath.endsWith('person_role') &&
            (!group.getValueForField(f.absolutePath) ||
                group.getValueForField(f.absolutePath).includes(currentRole))));
    }
    onNext(e) {
        if (this.hasNextRole()) {
            this.onNextRole(e);
        }
        else if (this.props.hasNextGroup) {
            this.props.onNextGroup();
        }
        else {
            this.props.onShowSummaryPage();
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return (this.state.amountOfDeletedItems !== nextState.amountOfDeletedItems ||
            this.props.group.groupId !== nextProps.group.groupId ||
            this.props.hasNextGroup !== nextProps.hasNextGroup ||
            this.props.hasPreviousGroup !== nextProps.hasPreviousGroup ||
            this.state.currentRole !== nextState.currentRole);
    }
    render() {
        var _a;
        const { error, group, hasPreviousGroup, onPreviousGroup, isLoading, t, tArray } = this.props;
        const { currentRole } = this.state;
        const hasNextRole = this.hasNextRole();
        const hasPreviousRole = this.hasPreviousRole();
        const currentRoleFields = this.getCurrentRoleFields(currentRole);
        return (React.createElement(ContainerTemplate, { title: t(`group.stakeholders.${currentRole}.title`) || group.fallbackTitle, subtitle: ((_a = tArray(`group.stakeholders.${currentRole}.subtitle`)) === null || _a === void 0 ? void 0 : _a.map(({ text, link }, index) => link ? (React.createElement(Link, { key: index, href: link, target: "_blank" }, text)) : (React.createElement("span", { key: index }, text)))) || group.fallbackSubtitle, error: error },
            React.createElement(StakeholderSubGroupComponent, { canGoBack: hasPreviousGroup || hasPreviousRole, canSkipRole: hasNextRole, forceUpdate: () => this.forceUpdate(), group: group, isLoading: isLoading, onBack: hasPreviousRole ? this.onPreviousRole : onPreviousGroup, onNext: this.onNext, role: currentRole, stakeholderItems: currentRoleFields, max: group.maxItems, min: group.minItems, t: t })));
    }
}
